import themeable from 'rlink-theme/themeable';
import {createElement, PropTypes} from 'rlink-react';
import {mergeStaticOptions} from 'rlink-utils/object';

import InputBase from './InputBase';

export default class RadioGroupInput extends InputBase {
  get inputType () {
    return 'radio';
  }

  get choices () {
    return this.fromPropsOrContext('choices');
  }

  handleChange (ev) {
    if (ev.target.checked) {
      let value = this.choices[Number(ev.target.value)].value;
      this.fireCommitValue(ev, value);
      return super.handleChange({
        event: ev,
        value,
      });
    }
  }


  hasValue (value) {
    return value !== undefined && value !== null;
  }

  renderLabel (label) {
    if (typeof label === 'object'
        && label !== null
        && '__html' in label) {
      return (<span
        className="labelText"
        dangerouslySetInnerHTML={label} />);
    } else {
      return (<span className="labelText">
        {label}
      </span>);
    }
  }

  labelClass (option) {
    let className = '';
    if ('classNames' in option) {
      className += option.classNames.map(className => (this.props.theme[className])).join(' ');
    }

    if (this.value === option.value) {
      className += ` ${(this.props.theme)
        ? this.props.theme.Checked
        : ''}`;
    }

    return className;
  }

  renderInput () {
    return this.choices.map((option, idx) =>
      <label key={idx}
        className={this.labelClass(option)}>
        <input type={this.inputType}
          disabled={this.disabled}
          name={this.name}
          onFocus={ev => this.handleFocus(ev)}
          onBlur={ev => this.handleBlur(ev)}
          onChange={ev => this.handleChange(ev)}
          checked={(this.value === option.value)}
          value={idx} />
        {this.renderLabel(option.label)}
      </label>);

  }

  render () {
    return (<div className={`control ${this.className}`}>
      {this.renderInput()}
      {this.renderHelp()}
      {this.renderError()}
    </div>);
  }
}


mergeStaticOptions(RadioGroupInput, {
  propTypes: {
    choices: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.shape({
          __html: PropTypes.string,
        }),
      ]),
      value: PropTypes.any,
    })),
  },
  defaultProps: {
    choices: [],
  },
});

themeable(RadioGroupInput, {
  classes: [
    'InputRadio',
    'Checked',
  ],
});



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/RadioGroupInput.jsx